import { unwrap } from "@scayle/storefront-core/dist/utils/response";
import { useNuxtApp, useAsyncData } from "nuxt/app";
import { useCoreLog } from "../useCoreLog.js";
import { useCurrentShop } from "./useCurrentShop.js";
import { extendPromise } from "../../utils/promise.js";
import { toValue, computed, isRef } from "#imports";
import { useRuntimeConfig } from "#app/nuxt";
function getFetch(nuxtApp, log) {
  const fetch = nuxtApp.ssrContext?.event.$fetch ?? $fetch;
  if (nuxtApp.ssrContext?.event && !nuxtApp.ssrContext?.event.$fetch) {
    log.error("event.$fetch was not found!");
  }
  return fetch;
}
export function useRpc(method, key, params, options) {
  const currentShop = useCurrentShop();
  const log = useCoreLog("rpc");
  const nuxtApp = useNuxtApp();
  const { public: { storefront: { disableDefaultGetCachedDataOverride } } } = useRuntimeConfig();
  if (options && options.autoFetch !== void 0) {
    log.warn("autoFetch is disabled; use immediate instead");
    if (options.immediate === void 0) {
      options.immediate = options.autoFetch;
    } else {
      log.warn("autoFetch will be ignored because immediate was specified");
    }
  }
  const asyncData = useAsyncData(
    key,
    async () => {
      const apiBasePath = currentShop.value?.apiBasePath ?? "/api";
      const fetch = getFetch(nuxtApp, log);
      return await unwrap(
        await fetch(`/rpc/${method}`, {
          // @ts-expect-error Type '"POST"' is not assignable to type 'AvailableRouterMethod<`/rpc/${N}`> | Uppercase<AvailableRouterMethod<`/rpc/${N}`>> | undefined'.ts(2322)
          method: "POST",
          body: {
            payload: toValue(params)
          },
          baseURL: apiBasePath,
          headers: {
            "x-shop-id": currentShop.value?.shopId + ""
          }
        })
      );
    },
    {
      // Both refs and getter functions are valid watch sources
      ...isRef(params) || typeof params === "function" ? { watch: [params] } : {},
      dedupe: 'defer',
      ...options
    }
  );
  return extendPromise(asyncData, {
    /** @deprecated - use refresh instead */
    fetch: asyncData.refresh,
    /** @deprecated - use `status.value === 'pending'´ instead */
    fetching: computed(() => asyncData.status.value === "pending")
  });
}
